<template>
    <div class="wh100">
        <div>
            <el-table :data="deviceRequireActRecList" :height="500+'px'" border style="width: 100%" class="mt30">
                <el-table-column prop="ts" label="操作时间" align="center" width="180"></el-table-column>
                <el-table-column prop="comName" label="部门" width="300" align="left"></el-table-column>
                <el-table-column prop="actRole" label="岗位" width="160" align="center"></el-table-column>
                <el-table-column prop="actorName" label="操作人" width="100" align="left"></el-table-column>
                <el-table-column prop="action" label="动作" width="70" align="center"></el-table-column>
                <el-table-column prop="actDesc" label="附加信息" show-overflow-tooltip align="left"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import devcReqrApi from '../../api/devcReqr'
    import {getDefaultPageSizes} from '../../app.conf'

    export default {
        name: 'swb-device-require-act-rec-list',
        desc: '设备请购单-操作记录',
        props: ['voucherId'],
        data: function () {
            return {
                deviceRequireActRecList: []
            }
        },

        created: function () {
            this.getDeviceRequireActRecList();
        },
        methods: {
            getDeviceRequireActRecList: function () {
                let self = this;
                let postParam = {};
                postParam.voucherId = self.voucherId;
                devcReqrApi.getDeviceRequireActRecListByVoucherId(postParam, function (result) {
                    if (result.type == "info") {
                        self.deviceRequireActRecList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireActRecList.vue